import { render, staticRenderFns } from "./NewTiptapEditor.vue?vue&type=template&id=398e8448&scoped=true"
import script from "./NewTiptapEditor.vue?vue&type=script&lang=js"
export * from "./NewTiptapEditor.vue?vue&type=script&lang=js"
import style0 from "./NewTiptapEditor.vue?vue&type=style&index=0&id=398e8448&prod&scoped=true&lang=css"
import style1 from "./NewTiptapEditor.vue?vue&type=style&index=1&id=398e8448&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398e8448",
  null
  
)

export default component.exports